
/* injects from baggage-loader */

'use strict';

export default class AccountController {

	constructor($log, $rootScope) {
		'ngInject';

		this.$log = $log;
		this.$rootScope = $rootScope;

		this.user_first_name = '';

	}

	$onInit() {

		// Set the users first name to be used in the greeting
		this.user_first_name = this.profile.get('first_name');

		// Listen for updates to the user profile
		this.$rootScope.$on('userProfileUpdated', event => {
			this.user_first_name = this.profile.get('first_name');
		});

	}


}



// WEBPACK FOOTER //
// ./src/app/pages/account/account.controller.js